import { render, staticRenderFns } from "./tongueTriangleS.vue?vue&type=template&id=e75a723e&"
import script from "./tongueTriangleS.vue?vue&type=script&lang=js&"
export * from "./tongueTriangleS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports